import { createContext, useContext } from "react";

export type QuickCaptureApi = { open: () => void; close: () => void; isOpen: boolean };

export const QuickCaptureContext = createContext<QuickCaptureApi>({
  open: () => {},
  close: () => {},
  isOpen: false,
});

export function useQuickCapture(): QuickCaptureApi {
  return useContext(QuickCaptureContext);
}
